export * from './navigation.service';

import {NavigationService} from './navigation.service';

export const NAVIGATION_SERVICES = [
    NavigationService
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/navigation/index.ts